module.exports = __webpack_public_path__ + "img/thumb-video.12ed3cc8.png";